import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Text,
} from "@fluentui/react-components";
import WarningIcon from "~icons/material-symbols/warning";
import { useCallback } from "react";
import { useAppData } from "../../../hooks";

type ExportWarningDialogProps = {
  appId: string;
  handleDownload: () => void;
};

export const ExportWarningDialog = ({ appId, handleDownload }: ExportWarningDialogProps) => {
  const [isExportModalOpen, setIsExportModalOpen] = useAppData<boolean>(appId, "isExportModalOpen", false);

  const handleCancel = () => {
    setIsExportModalOpen(false);
  };

  const handleDownloadAnyway = useCallback(() => {
    setIsExportModalOpen(false);
    // use 0 timeout to ensure the dialog close state is rendered before starting the download process
    setTimeout(() => {
      handleDownload();
    }, 0);
  }, [handleDownload, setIsExportModalOpen]);

  return (
    <Dialog open={isExportModalOpen} onOpenChange={(_, data) => !data.open && handleCancel()}>
      <DialogSurface style={{ width: "80%", maxWidth: "500px" }}>
        <DialogBody className="flex flex-col gap-2 ">
          <div className="flex justify-center">
            <WarningIcon style={{ fontSize: "48px", color: "#FF9F43" }} />
          </div>

          <DialogTitle style={{ textAlign: "center", fontWeight: "bold" }}>File may not contain all text</DialogTitle>

          <DialogContent>
            <Text size={400} weight="medium" align="center" style={{ display: "block", marginBottom: "1.5rem" }}>
              Some text blocks in your export exceed the maximum length allowed in an Excel file. As a result, Excel
              will truncate the text in certain cells.
            </Text>
          </DialogContent>

          <DialogActions className="flex gap-3">
            <Button appearance="primary" onClick={handleDownloadAnyway} className="flex-1">
              Download Anyway
            </Button>
            <Button appearance="secondary" onClick={handleCancel} className="flex-1">
              Cancel
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
